<template>
  <div class="formContainer">

    <form class="formularioBusqueda" @submit.prevent="loadOrderData">

      <div class="formGroup">
        <label>Documento</label>

        <select v-model="selectedDocument" required>
          <option value="" disabled>Seleccione...</option>

          <option
            v-for="document in documentsData"
            :key="document.documento"
            :value="document.documento"
          >
            {{ document.documento }}
          </option>

        </select>
      </div>

      <div class="formGroup">
        <label>Periodo</label>

        <input
          type="text"
          v-model.trim="selectedPeriod"
          placeholder="Ingrese el periodo"
          required
        />
      </div>

      <div class="formGroup">
        <label>Orden</label>

        <input
          type="text"
          v-model.trim="selectedOrder"
          placeholder="Ingrese la orden"
          required
        />
      </div>

      <div class="formActions">
        <button type="submit" class="loginbtn primaryBtn">
          Buscar
        </button>
      </div>

    </form>

  </div>
</template>
<script>
//Importa el componente de Vuex
import IberoHelpers from '@/store/helpers.js'

  export default {
    components: {
        IberoHelpers,
    },
    data () {
      return {
        documentsData : [],
        selectedDocument : null,
        selectedPeriod : null,
        selectedOrder : null,
        orderData : [],
      }
    },
    mounted () {
       this.loadDocumentsData();
    },
    methods: {
        //Método que carga los datos del select de "Documento"
        loadDocumentsData(){
          IberoHelpers.GetOrdenDocumentsIceberg(this.$store, 0)
                .then(response => {
                    this.documentsData = response.data;
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                });
        },
        //Método que carga los datos de las ordenes desde Iceberg, se le pasa "Cliente", "Documento" y "Orden" como parámetros
        async loadOrderData() {
          try {
            let response = await IberoHelpers.GetOrderIceberg(this.$store, this.selectedPeriod, this.selectedDocument, this.selectedOrder);

            if (response.data.length === 0) {
              this.orderData = [{
                Registro: 0,
                Secuencia: 0,
                ColumnName: "",
                ValorAnterior: "",
                ValorAccion: "",
                Accion: "",
                Fecha: "",
                Terminal: "",
                Usuario: "",
                ObjectName: ""
              }]; // Objeto por defecto
            } else {
              this.orderData = response.data;
            }
            this.$emit('showResultOrder', this.orderData);
          } catch (error) {
            console.error('Error loading data:', error);
          }
        }
        
    },
  }
</script>